import { customAlphabet } from "nanoid";

export const uniqueId = (length = 16): string => {
  const nanoid = customAlphabet("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", length);

  return nanoid();
};
